module.exports = require('../dist/compat/math/sumBy.js').sumBy;
